// Base path for the conversations-service question-classification summary API.
// The summary endpoint lives at `${QUESTION_INSIGHTS_API}/summary`.
export const QUESTION_INSIGHTS_API = "/api/conversations/v1/classifications";

export const QUESTION_INSIGHTS_PAGE_TITLE = "AI Session Query Insights";

// The originating apps the dashboard reports on: the go-forward Project session
// (nextgen) and its legacy predecessor, the Dataset Assistant. Sent to the
// summary endpoint so every figure covers just these two apps.
export const QUESTION_INSIGHTS_APP_IDS = ["PROJECT_ASSISTANT", "DATASET_ASSISTANT"] as const;
